import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MaterialesApoyoPage } from './materiales-apoyo';
import { ComponentsModule } from '../../components/components.module';
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    MaterialesApoyoPage,
  ],
  imports: [
    IonicPageModule.forChild(MaterialesApoyoPage),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
    ComponentsModule,
    DirectivesModule
  ],
})
export class MaterialesApoyoPageModule {}



// WEBPACK FOOTER //
// ./src/pages/materiales-apoyo/materiales-apoyo.module.ts